// import GraphQlDemo from './GraphQlDemo'
import '@reach/skip-nav/styles.css'
import LogOut from '../GateKeeper/LogOut'
import SpacesSideNav from './SpacesSideNav/SpacesSideNav'
import Suspense from '../Suspense'
import {
  ENVIRONMENTS,
  HELP,
  LOG_OUT,
  Redirect,
  Router as RoutingRouter,
  SPACES,
  SPACE_API_ACCESS,
  SYSTEM,
  routeLabels
} from '@eggplant/routing'
import { Help } from '@eggplant/embedded-documentation'
import { SKIP_NAVIGATION } from '../constants'
import { SkipNavLink } from '@reach/skip-nav'
import { SpaceContext } from '@eggplant/context'
import {
  lazy,
  useContext,
  useEffect,
  useState
} from 'react'
import {
  navigate,
  useLocation
} from '@reach/router'
import { pathToRetainUponRefresh } from '../GateKeeper/SpaceCheckpoint/constants'
import type { CSSProperties } from 'react'
import SpaceAnnouncementPopOut from './SpaceAnnouncementPopOut/SpaceAnnouncementPopOut'
import {
  get,
  set
} from 'browser-cookies'
import { CentralModal } from '@eggplant/pattern-library'

const SpacesRoute = lazy(() => import(/* webpackChunkName: 'SpacesRoute' */ './SpaceRouter'))
const EnvironmentRouter = lazy(() => import(/* webpackChunkName: 'EnvironmentRouter' */ './EnvironmentRouter'))
const SystemRouter = lazy(() => import(/* webpackChunkName: 'SystemRouter' */ './SystemRouter'))
const ApiAccessRouter = lazy(() => import(/* webpackChunkName: 'ApiAccessRouter' */ './ApiAccessRouter'))

const wrapperStyle: CSSProperties = {
  display: 'flex',
  height: '100%',
  flexDirection: 'row',
  alignItems: 'flex-start'
}

const srOnly: CSSProperties = {
  position: 'absolute',
  padding: '10px',
  overflow: 'hidden'
}

const WILDCARD = '/*'

const labels = Object.keys(routeLabels)

const COOKIE_NAME = 'isReleaseNoteSeen'

const Spaces = () => {
  const { pathname } = useLocation()
  const spaceContext = useContext(SpaceContext)
  const [isOpen, setIsOpen] = useState(get(COOKIE_NAME) !== '1')

  useEffect(() => {
    // eslint-disable-next-line fp/no-mutating-methods
    const label = pathname
      .split('/')
      .reverse() // match children before parents
      .find(
        token => labels.includes(token)
      ) as keyof typeof routeLabels | undefined

    // eslint-disable-next-line fp/no-mutation
    document.title = label
      ? `DAI - ${routeLabels[label]}`
      : 'Eggplant DAI'

    const isPreventNavigateWhenNoSpaceId = pathToRetainUponRefresh.some(path => pathname.startsWith(path))

    // when no selectedSpaceId navigate to SPACES route
    if (!isPreventNavigateWhenNoSpaceId && !spaceContext?.selectedSpaceId) {
      void navigate(`/${SPACES}`)
    }
  }, [pathname, spaceContext?.selectedSpaceId])

  const handleClosePopout = () => {
    setIsOpen(false)
    set(COOKIE_NAME, '1')
  }

  return (
    <>
      <div style={wrapperStyle}>
        {
        // Prevent the sidebar from loading until Redirect resolve
        // this loads faster and prevents the sidebar from setting isCurrent based on null match
          pathname !== '/' &&
          <>
            <SkipNavLink
              contentId={SKIP_NAVIGATION}
              style={srOnly}
            >
              Skip navigation
            </SkipNavLink>
            <SpacesSideNav />
          </>
        }
        <Suspense>
          <RoutingRouter isFlex>
            <Redirect
            // @ts-expect-error
              path='/'
              to={SPACES}
            />
            <SpacesRoute
            // @ts-expect-error
              path={SPACES + WILDCARD}
            />
            <ApiAccessRouter path={SPACE_API_ACCESS + WILDCARD} />
            <EnvironmentRouter path={ENVIRONMENTS + WILDCARD} />
            <SystemRouter path={SYSTEM + WILDCARD} />
            <Help
            // @ts-expect-error
              path={HELP}
            />
            <LogOut
            // @ts-expect-error
              path={LOG_OUT}
            />
          </RoutingRouter>
        </Suspense>
      </div>
      <CentralModal
        isOpen={isOpen}
        label='announcementPopOut'
        onRequestClose={handleClosePopout}
      >
        <SpaceAnnouncementPopOut onClose={handleClosePopout}/>
      </CentralModal>
    </>
  )
}

export default Spaces